import Typography from '@mui/material/Typography'
import { css, styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const PARTICIPANT_CARD_MIN_WIDTH = 200
export const PARTICIPANT_COLLAPSED_AVATAR_DIMENSION = 59
export const PARTICIPANT_COLLAPSED_AVATAR_OVERLAP = 15

export const AttendeesWrapper = styled('div')`
  background-color: ${colors.commonLightGrey};
  padding: ${componentSizes.smDistance};
  border-radius: 4px;
  width: 100%;

  ${(props: { smallViewMode?: boolean }) =>
    props.smallViewMode
      ? css`
          background: none;
          padding: 0 0 ${componentSizes.smDistance};
        `
      : ''}
`

export const AttendeesTitle = styled(Typography)`
  color: ${colors.bodyText};
`
export const AttendeesEventName = styled('div')`
  color: ${colors.primary};
  margin-bottom: 10px;
`

export const AttendeesListWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
`
export const AttendeesExpandedList = styled('div')`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: stretch;
`

export const ParticipantCard = styled('div')`
  display: flex;
  flex-direction: row;
  min-width: ${PARTICIPANT_CARD_MIN_WIDTH}px;
  &:not(:first-child) {
    padding-left: 10px;
    margin-left: 10px;
    border-left: 1px solid ${colors.darkerGray};
  }

  ${(props: { inPopoverList?: boolean }) =>
    props.inPopoverList
      ? css`
          padding: 8px ${componentSizes.smDistance};
          &:not(:first-child) {
            border-top: 1px solid ${colors.commonLightGrey};
            padding-left: ${componentSizes.smDistance};
            border-left: none;
          }
        `
      : ''}
`

export const ParticipantItemBox = styled('div')`
  width: ${PARTICIPANT_COLLAPSED_AVATAR_DIMENSION}px;
  height: ${PARTICIPANT_COLLAPSED_AVATAR_DIMENSION}px;
  border-radius: 50%;
  overflow: hidden;
  background-color: ${colors.grey};
  box-shadow: -1px 0 4px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
  margin-right: 10px;
  & img {
    width: 100%;
    height: 100%;
  }

  ${(props: { collapsedMode?: boolean; $isDisabled?: boolean }) =>
    props.collapsedMode
      ? css`
          margin-right: -${PARTICIPANT_COLLAPSED_AVATAR_OVERLAP}px;
          pointer-events: ${props.$isDisabled ? 'none' : 'auto'};
          opacity: ${props.$isDisabled ? '0.2' : '1'};
          pointer-events: ${props.$isDisabled ? 'none' : 'all'};
        `
      : ''}
`
export const ParticipantAltInfo = styled('div')`
  font-size: 25px;
  font-weight: 500;
  line-height: ${PARTICIPANT_COLLAPSED_AVATAR_DIMENSION}px;
  text-align: center;
  color: ${colors.bodyText};
`

export const ParticipantInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
export const ParticipantName = styled(Typography)`
  color: ${colors.primary};
`

export const ContactIcon = styled('div')`
  width: 50px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background-color: ${colors.primary};
  cursor: pointer;
  & svg {
    fill: ${colors.white};
    font-size: 25px;
  }
`
